import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import appInfo from '../constants/appInfo';
import './ContactPage.css';

// 🔑 Get your free access key at https://web3forms.com (no signup needed —
// just enter appInfo.supportEmail and it gives you a key instantly).
// Every form submission is emailed straight to that inbox.
const WEB3FORMS_ACCESS_KEY = 'e49bfbab-505a-4131-87ff-fd201edf193d';

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `Dhenika Support — ${form.name}`,
          from_name: 'Dhenika Website',
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSent(true);
      } else {
        setError('Something went wrong. Please try again or email us directly.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page">
      <Navbar />
      <main className="contact-page__main">
        <div className="contact-page__container">

          <div className="contact-page__breadcrumb">
            <Link to="/" className="contact-page__back">← Back to Home</Link>
          </div>

          <div className="contact-page__grid">

            {/* ── Left: Info ── */}
            <div className="contact-page__info">
              <h1 className="contact-page__title">Contact Us</h1>
              <p className="contact-page__subtitle">
                Have a question or need help? We'd love to hear from you.
                Our team is here to support every farmer using Dhenika.
              </p>

              <div className="contact-page__cards">
                <div className="contact-page__card">
                  <span className="contact-page__card-icon">📧</span>
                  <div>
                    <p className="contact-page__card-label">Email Support</p>
                    <a
                      href={`mailto:${appInfo.supportEmail}`}
                      className="contact-page__card-value"
                    >
                      {appInfo.supportEmail}
                    </a>
                  </div>
                </div>

                <div className="contact-page__card">
                  <span className="contact-page__card-icon">⏰</span>
                  <div>
                    <p className="contact-page__card-label">Response Time</p>
                    <p className="contact-page__card-value">Within 24 hours</p>
                  </div>
                </div>

                <div className="contact-page__card">
                  <span className="contact-page__card-icon">🌐</span>
                  <div>
                    <p className="contact-page__card-label">Languages</p>
                    <p className="contact-page__card-value">Hindi, Marathi & English</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Right: Form ── */}
            <div className="contact-page__form-wrap">
              {sent ? (
                <div className="contact-page__success">
                  <span className="contact-page__success-icon">✅</span>
                  <h3>Message Sent!</h3>
                  <p>Thanks for reaching out — our team will get back to you within 24 hours.</p>
                  <button
                    className="contact-page__reset"
                    onClick={() => { setSent(false); setForm({ name: '', email: '', message: '' }); }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className="contact-page__form" onSubmit={handleSubmit}>
                  <h2 className="contact-page__form-title">Send us a message</h2>

                  <div className="contact-page__field">
                    <label className="contact-page__label" htmlFor="name">Your Name</label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      className="contact-page__input"
                      placeholder="e.g. Ramesh Patel"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact-page__field">
                    <label className="contact-page__label" htmlFor="email">Email Address</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="contact-page__input"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact-page__field">
                    <label className="contact-page__label" htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      className="contact-page__textarea"
                      placeholder="How can we help you?"
                      rows={5}
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {error && <p className="contact-page__error">{error}</p>}

                  <button type="submit" className="contact-page__submit" disabled={sending}>
                    {sending ? 'Sending…' : 'Send Message →'}
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ContactPage;